var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    clipPath: "url(#clip-phone)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    d: "M21.372,15.546,16.56,13.484a1.031,1.031,0,0,0-1.2.3l-2.131,2.6A15.927,15.927,0,0,1,5.612,8.771l2.6-2.131a1.029,1.029,0,0,0,.3-1.2L6.45.624a1.038,1.038,0,0,0-1.182-.6L.8,1.058A1.031,1.031,0,0,0,0,2.063,19.936,19.936,0,0,0,19.938,22a1.031,1.031,0,0,0,1.005-.8l1.031-4.469a1.044,1.044,0,0,0-.6-1.186Z",
    transform: "translate(3 4)",
    fill: "#416fd8"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.a2d698c7.svg";
export { ForwardRef as ReactComponent };